export const SAVE_HOME_IMAGE = 'SAVE_HOME_IMAGE'
export const RESET_HOME_IMAGE = 'RESET_HOME_IMAGE'

export const saveHomeImage = (homeImage) => ({ type: SAVE_HOME_IMAGE, homeImage })
export const resetHomeImage = () => ({ type: RESET_HOME_IMAGE })